module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBg0OAxNPfwJDAAAAc0lEQVRIx+3VsQ2AIBCF4aeFe1g4gWE9C1diDexJKNzD5re14UIwEQtecQ2XL5C7BMkIjkDAqTZ4ALzVM5rC8qhVQEE60IF/AANOW3bbZ02SLp2Z86R9IGh9cYGj/RNMnQhAtHraj7EDHfgASI9ak5Lv/Qb6aypvnFC6HQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNi0xM1QxNDowMzoxOSswMjowMLUysEgAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDYtMTNUMTQ6MDM6MTkrMDI6MDDEbwj0AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add.png
// module id = 125
// module chunks = 0